/**
 * Solve quadratic equation in form of ax^2 + bx + c = 0
 */
import { squared } from './numbers';

export function solveQuadratic(a: number, b: number, c: number): number[] {
  if (a === 0) {
    if (b === 0) {
      if (c === 0) {
        throw new Error(
          'All coefficients cannot be zero - that means X can be any number',
        );
      }
      return [];
    }
    return [-c / b];
  }
  const d = squared(b) - 4 * a * c;
  if (Math.abs(d) <= Number.EPSILON) {
    // double root
    return [-b / (2 * a)];
  }
  if (d < 0) {
    // no root
    return [];
  }
  // two roots
  const sqrtD = Math.sqrt(d);
  return [(-b - sqrtD) / (2 * a), (-b + sqrtD) / (2 * a)];
}
